module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"version":"Version","theme":"Theme Preset","platforms":"Platforms","categories":"Categories","customize":"Customize"},"ja":{"version":"バージョン","theme":"テーマプリセット","platforms":"プラットフォーム","categories":"カテゴリー","customize":"カスタマイズ"}}')
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/yaml-loader!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/TRMenu.vue
// module id = yuGJ
// module chunks = 1